import { Typography } from "@mui/material";
import { PolicyIcon } from "~/icons";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

export function renderAssetEmptyStateContent({
  target,
  scope,
}: {
  target: "checks" | "policies";
  scope: SpaceScope | OrganizationScope | undefined;
}) {
  return {
    icon: <PolicyIcon sx={{ fontSize: 38, color: "primary.main" }} />,
    headline: `No ${target} to show!`,
    textContent: (
      <Typography color="text.secondary" sx={{ textAlign: "center" }}>
        Check out the available policies to find one that matches your security
        goals and your infrastructure
      </Typography>
    ),
    actionButtons: scope && [
      {
        text: "Add Policies",
        to: `/space/findings/policies/add?${scope.params}`,
      },
    ],
  };
}
